import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Menu from "./components/Menu";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import Locations from "./components/Locations";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-stone-950">
      <Header />
      <main>
        <Hero />
        <Menu />
        <About />
        <Testimonials />
        <Locations />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;